export function InsuranceCartIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0174 2.08405L20.0336 3.91702L20.0697 16.4472L12.0166 21.8974L3.9658 16.4487L3.92969 3.9166L12.0174 2.08405ZM5.43314 5.11396L5.46351 15.6511L12.0166 20.0861L18.5674 15.6527L18.537 5.11354L12.0158 3.62241L5.43314 5.11396ZM16.004 10.3088L11.0415 15.2712L8.01812 12.2478L9.07878 11.1872L11.0415 13.1499L14.9433 9.24811L16.004 10.3088Z"
        fill="#101010"
      />
    </svg>
  )
}
